<template xmlns="http://www.w3.org/1999/html">
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Tips')"
    width="400px"
    :close-on-click-modal="false"
    :show-close="true"
  >
    <div style="display: flex">
      <div class="el-message-box__status el-icon-success" />
      <div style="padding-left: 32px;">
        <span style="font-size: 20px">{{ $t('CargoMsg.Cargo_ImportingData') }}</span><br>
        <span style="color: red">{{ $t('CargoMsg.Cargo_ImportingDataSuccess1') }}
          <a href="javascript:void(0)" style="border-bottom: 1px solid;color: blue;" @click="judgePage">
            {{ $t('CargoMsg.Cargo_ImportingDataSuccess2') }}</a>
          {{ $t('CargoMsg.Cargo_ImportingDataSuccess3') }}</span>
      </div>
    </div>
    <div slot="footer">
      <el-button no="cancel" @click="cancelHandler">{{ $t('common.btn.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'FileUploadSuccessDialog',
  props: {
    visible: { type: Boolean, required: true },
    code: { type: Number, required: false, default: 0 }
  },
  data() {
    return {
      innerVisible: false
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    judgePage(event) {
      this.$emit('cancelCallback')
      this.$router.push({ name: 'PriceFileManager', params: { code: this.code }})
    },
    cancelHandler() {
      this.innerVisible = false
      this.$emit('cancelCallback')
    }
  }
}
</script>
